import { Fragment } from 'react';
import { observer } from 'mobx-react';

import GlobalAccessRestrictedDescription from '@/security/components/BaseGlobalAccessModal/GlobalAccessRestrictedDescription/GlobalAccessRestrictedDescription';
import GlobalDataAssessRadio from '@/security/components/BaseGlobalAccessModal/GlobalDataAssessRadio/GlobalDataAssessRadio';
import { DRIVE_PROJECT_DATA_ACCESS } from '@/security/constants/dataAccess';
import { GlobalAccessLevel } from '@/security/constants/GlobalAccessLevel';
import { ProjectDataAccess } from '@/security/types/DataAccess';

import { useDriveGlobalAccessModalStore } from '../../DriveGlobalAccessModalStore';

function DataAccessColumn() {
  const { access, dataAccess, isUpdating, setDataAccess } = useDriveGlobalAccessModalStore();

  if (access === GlobalAccessLevel.Restricted) {
    return (
      <GlobalAccessRestrictedDescription>
        <span>Data is available only to company employees.</span>
      </GlobalAccessRestrictedDescription>
    );
  }

  return (
    <Fragment>
      {DRIVE_PROJECT_DATA_ACCESS.map((option) => (
        <GlobalDataAssessRadio
          aria-label={option.title}
          key={option.id}
          checked={dataAccess === option.id}
          description={option.description}
          disabled={isUpdating}
          iconName={option.icon}
          id={option.id}
          onChange={(nextDataAccess) => setDataAccess(nextDataAccess as ProjectDataAccess)}
          title={option.title}
        />
      ))}
    </Fragment>
  );
}

export default observer(DataAccessColumn);
